// extracted by mini-css-extract-plugin
export default {"container":"Header_container__plBHi","headline":"Header_headline__uY-Pm","goBackButton":"Header_goBackButton__bqfHX"};